import * as SMloggedInUserIMDCodesActions from './../actions/SMloggedInUserIMDCodes.action';
import { AppState } from '../state/App.state';
import { SMLoggedInUserIMDCodesModel } from '../models/SMloggedInUserDetails.model';

const initialState = {
    SMIMDCodesDetails: []
}

export function SMloggedInUserBusinessCodesDataReducer(state: SMLoggedInUserIMDCodesModel = initialState, action: SMloggedInUserIMDCodesActions.Actions) {

    switch (action.type) {
        case SMloggedInUserIMDCodesActions.UPDATE_SM_LOGGEDIN_USER_IMD_CODES:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}
export const selectSMLoggedInUserIMDCodes = (state: AppState) => state.SMloggedInUserIMDCodes;